import React from "react";

// styles
import * as Styled from './styles'

function Table(props) {
    function handleSource (source) {
        const type = source.replace('resources.', '') // for scrum alliance
        var www_out = type.includes('www') ? type.substring(12) : type.substring(8)
        return www_out.substring(0, www_out.indexOf('/'))
    }

    return (
        <div>
            <Styled.ResultsTable>
                <tbody>
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Author</th>
                        <th>Date</th>
                        <th>Source</th>
                        <th>Type</th>
                    </tr>
                    
                    { props.results &&
                        props.results.map((post, idx) => {
                            return <tr key={ idx }>
                                <td>{ idx }</td>
                                <td><a href={ post.link }>{ post.titulo }</a></td>
                                <td>{ post.autor }</td>
                                <td>{ post.data }</td>
                                <td>{ handleSource(post.link) }</td>
                                <td>{ post.tipo }</td>
                            </tr>
                        })
                    }
                </tbody>
            </Styled.ResultsTable>
        </div>
    );
    }

export default Table;
